import React from 'react';
import { ErrorMessage } from 'formik';
import { FieldContainer, Label, RequiredStar, InputField, TextAreaField, ErrorText } from '../Styles';

export default function FormField({
  name,
  label,
  type = 'text',
  placeholder,
  maxLength,
  rows,
  required = false,
  error,
  touched,
  onChange, // Custom onChange handler
  value, // Pass value from parent
}) {
  const isError = error && touched;

  // If custom onChange is provided, use Field component with custom rendering
  if (onChange) {
    return (
      <FieldContainer>
        <Label>
          {label}
          {required && <RequiredStar>*</RequiredStar>}
        </Label>

        {type === 'textarea' ? (
          <TextAreaField
            name={name}
            placeholder={placeholder}
            rows={rows}
            $error={isError}
            value={value}
            onChange={onChange}
          />
        ) : (
          <InputField
            name={name}
            type={type === 'date' ? 'text' : type}
            placeholder={type === 'date' ? 'DD-MM-YYYY' : placeholder}
            maxLength={type === 'date' ? 10 : maxLength}
            $error={isError}
            value={value}
            onChange={onChange}
          />
        )}

        <ErrorMessage name={name}>
          {msg => <ErrorText>{msg}</ErrorText>}
        </ErrorMessage>
      </FieldContainer>
    );
  }

  // Default rendering without custom onChange
  return (
    <FieldContainer>
      <Label>
        {label}
        {required && <RequiredStar>*</RequiredStar>}
      </Label>

      {type === 'textarea' ? (
        <TextAreaField
          as="textarea"
          name={name}
          placeholder={placeholder}
          rows={rows}
          $error={isError}
        />
      ) : type === 'date' ? (
        <InputField
          name={name}
          type="text"
          placeholder="DD-MM-YYYY"
          maxLength="10"
          $error={isError}
        />
      ) : (
        <InputField
          name={name}
          type={type}
          placeholder={placeholder}
          maxLength={maxLength}
          $error={isError}
        />
      )}

      <ErrorMessage name={name}>
        {msg => <ErrorText>{msg}</ErrorText>}
      </ErrorMessage>
    </FieldContainer>
  );
}